// extracted by mini-css-extract-plugin
export default {"admin-download-row":"ImageDownload_admin-download-row__tWTFd","admin-download-":"ImageDownload_admin-download-__N4I6f"};